import { Button, IconButton } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { pushMessage } from '../../store/actions/app.action';
import { logout } from '../../store/actions/user.action';

const action = (
  <>
    <Button
      onClick={() => window.location.reload()}
      color="secondary"
      // variant="outlined"
      size="small"
    >
      Refresh
    </Button>
  </>
);

const AUTO_LOGOUT_TIME_MIN = 30;
const AUTO_LOGOUT_TIME_MS = AUTO_LOGOUT_TIME_MIN * 60 * 1000;
const AUTO_LOGOUT_MSGS = [
  {
    timeLeft: 10,
  },
  {
    timeLeft: 5,
    action: action,
  },
  {
    timeLeft: 1,
    action: action,
    actionRequired: true,
  },
];

const ChronJob = () => {
  const timestamp = useSelector(({ app }) => app.timestamp);
  const dispatch = useDispatch();
  const [timers, setTimers] = useState({ warning: [] });

  useEffect(() => {
    if (timers.logout) {
      clearTimeout(timers.logout);
      timers.warning.forEach((timer) => clearTimeout(timer));
    } else {
      dispatch(
        pushMessage(
          { msg: `You will be logged out in ${AUTO_LOGOUT_TIME_MIN} minutes.` }
        )
      );
    }

    // Auto logout after 15 minutes of no network calls
    const logoutTimer = setTimeout(
      () => dispatch(logout()),
      AUTO_LOGOUT_TIME_MS
    );
    const warningTimers = [];

    AUTO_LOGOUT_MSGS.forEach((timerSetting) => {
      const { timeLeft } = timerSetting;

      warningTimers.push(
        setTimeout(
          () =>
            dispatch(
              pushMessage({
                msg: `You will be logged out in ${timeLeft} ${timeLeft === 1 ? 'minute' : 'minutes'}.`,
                actionRequired: timerSetting.actionRequired,
                action: timerSetting.action,
              })
            ),
            Math.abs(timeLeft - AUTO_LOGOUT_TIME_MIN) * 60 * 1000,
        )
      );
    });

    setTimers({ logout: logoutTimer, warning: warningTimers });
  }, [timestamp]);

  return <div></div>;
};

export default ChronJob;
